import { centimos, importeTexto, validarFilaAutorizacion } from '@/helpers/autorizacionesTarjeta';

export function prepararDocumentos(registros, tarjetas) {
  const filas = new Map();
  registros.forEach(r => filas.set(Number(r.pasajero_id), { pasajero_id: r.pasajero_id, email_destinatario: String(r.email_destinatario || '').trim(), registro_viajeros: true }));
  tarjetas.forEach(t => {
    const error = validarFilaAutorizacion(t);
    if (error) throw new Error(error);
    const id = Number(t.pasajero_id);
    const fila = filas.get(id) || { pasajero_id: t.pasajero_id, email_destinatario: String(t.email_destinatario || '').trim(), registro_viajeros: false };
    if (fila.email_destinatario.toLowerCase() !== String(t.email_destinatario || '').trim().toLowerCase()) throw new Error('Usa el mismo correo para los dos documentos de cada pasajero.');
    fila.autorizacion_tarjeta = { autorizacion_importecarga: importeTexto(centimos(t.autorizacion_importecarga)), autorizacion_importedeposito: importeTexto(centimos(t.autorizacion_importedeposito)) };
    filas.set(id, fila);
  });
  const seleccionados = Array.from(filas.values());
  seleccionados.forEach(f => { if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(f.email_destinatario)) throw new Error('Todos los seleccionados deben tener un correo válido.'); });
  return seleccionados;
}

export function validarResultadoDocumentos(resultado, filas) {
  if (!resultado || !Array.isArray(resultado.envios) || !Array.isArray(resultado.data)) throw new Error('No se ha confirmado el envío.');
  filas.forEach(f => {
    const e = resultado.envios.filter(e => Number(e.pasajero_id) === Number(f.pasajero_id));
    if (e.length !== 1 || typeof e[0].enviado !== 'boolean') throw new Error('Respuesta de envío incompleta.');
    if (e[0].enviado && f.registro_viajeros && !resultado.data.some(r => Number(r.pasajero_id) === Number(f.pasajero_id) && r.enviado_at)) throw new Error('Falta la confirmación del registro.');
    if (e[0].enviado && f.autorizacion_tarjeta && !(resultado.autorizaciones || []).some(r => Number(r.pasajero_id) === Number(f.pasajero_id) && r.enviado_at)) throw new Error('Falta la confirmación de la tarjeta.');
  });
}
